<template>
    <label for="trendline">
        <input id="trendline" @change="emitInput" type="checkbox" name="show-trendline" v-model="value" class="mr-1" />
        Show Trendline
    </label>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps(['defaultValue']);
const emit = defineEmits(['update:modelValue']);

const value = ref(props.defaultValue);

function reset() {
    value.value = props.defaultValue;
}

function emitInput() {
    emit('update:modelValue', value.value);
}

defineExpose({
    reset
});
</script>
